import {
	Alert,
	Box,
	Button,
	CircularProgress,
	Snackbar,
	Typography,
} from '@mui/material';
import React, { useState } from 'react';
import AddIcon from '@mui/icons-material/Add';
import StorageOutlinedIcon from '@mui/icons-material/StorageOutlined';
import { maximusImport, mxemrimport } from '../../../services/api/apiManager';
function EMRimport() {
	// snackbar 1 code
	const [snackbarOpen, setSnackbarOpen] = useState(false);
	const handleOpenSnackbar = () => {
		setSnackbarOpen(true);
	};
	const [loading, setLoading] = useState(false);
	const handleCloseSnackbar = () => {
		setSnackbarOpen(false);
	};
	// snack bar 2 code
	const [snackbarOpenError, setSnackbarOpenError] = useState(false);
	const [errortext, seterrortext] = useState(false);
	const handleError = (text) => {
		seterrortext(text);
		setSnackbarOpenError(true);
	};
	const handleCloseError = () => {
		setSnackbarOpenError(false);
	};
	const OSW_id = localStorage.getItem('OSW_id');
	const data = {
		OSW_id: OSW_id,
		OSWPractice_id: localStorage.getItem('OID'),
		action: 'patientlist',
	};
	const handleClick = async () => {
		// Increment the click count
		setLoading(true);
		if (OSW_id == '1') {
			try {
				const res = await maximusImport(data);
				if (res?.status === 200) {
					handleOpenSnackbar(); // Display a success message
				} else {
					handleError(res?.response?.data?.err);
				}
			} catch (error) {
				console.log('An error occurred: ', error);
				handleError(); // Show an error message
			}
		} else if (OSW_id == '2') {
			try {
				const res = await mxemrimport(data);
				if (res?.status === 201 || res?.status === 200) {
					handleOpenSnackbar(); // Display a success message
				} else {
					handleError(res?.response?.data?.err);
				}
			} catch (error) {
				console.log('An error occurred: ', error);
				handleError(); // Show an error message
			}
		}
		setLoading(false);
	};
	return (
		<>
			<Box
				sx={{
					minHeight: 'calc(100vh - 170px)',
					width: '100%',
					background: '#f5f8fc',
					border: '1px solid #e3edf8',
					borderRadius: '8px',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					p: 2,
				}}
			>
				<Box
					sx={{
						width: 'min(560px, 100%)',
						minHeight: 330,
						background: '#fff',
						border: '1px solid #dce8f5',
						borderRadius: '16px',
						boxShadow: '0 24px 55px rgba(15, 23, 42, 0.08)',
						display: 'flex',
						flexDirection: 'column',
						alignItems: 'center',
						justifyContent: 'center',
						textAlign: 'center',
						px: { xs: 3, sm: 5 },
						py: 4,
					}}
				>
					<Box
						sx={{
							width: 78,
							height: 78,
							borderRadius: '50%',
							background: '#eaf2ff',
							color: '#0f63ff',
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							mb: 2.3,
						}}
					>
						<StorageOutlinedIcon sx={{ fontSize: 34 }} />
					</Box>
					<Typography
						sx={{
							fontSize: { xs: '20px', sm: '20px' },
							fontWeight: 600,
							color: '#020b1c',
							mb: 1.2,
						}}
					>
						{OSW_id == '1'
							? 'Import Data from Maximus'
							: 'Import Data from EMR'}
					</Typography>
					<Typography
						sx={{
							fontFamily: 'Poppins',
							fontSize: '14px',
							fontWeight: 400,
							color: '#526b91',
							lineHeight: 1.7,
							maxWidth: 390,
							mb: 3,
						}}
					>
						Easily import patient, billing, and clinical data from your EMR
						system in a few simple steps.
					</Typography>
					<Button
						onClick={() => handleClick()}
						disabled={loading}
						startIcon={
							loading ? (
								<CircularProgress size={16} sx={{ color: '#fff' }} />
							) : (
								<AddIcon fontSize="small" />
							)
						}
						sx={{
							minWidth: 230,
							height: 46,
							background: '#2f6edb',
							color: '#fff',
							borderRadius: '10px',
							fontFamily: 'Poppins',
							fontSize: '14px',
							fontWeight: 700,
							textTransform: 'none',
							boxShadow: '0 16px 26px rgba(20, 91, 215, 0.22)',
							'&:hover': {
								background: '#245fc5',
								boxShadow: '0 16px 26px rgba(20, 91, 215, 0.28)',
							},
							'&.Mui-disabled': {
								background: '#cfd7e6',
								color: '#fff',
								boxShadow: 'none',
							},
						}}
					>
						{OSW_id == '1'
							? 'Import Data from Maximus'
							: 'Import Data from EMR'}
					</Button>
				</Box>
			</Box>
			{/* SnacKbar 1*/}
			<Snackbar
				open={snackbarOpen}
				autoHideDuration={3000} // Adjust the duration as needed
				onClose={handleCloseSnackbar}
				anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
			>
				<Alert
					onClose={handleCloseSnackbar}
					severity="success"
					variant="filled"
				>
					Data Imported successfully.
				</Alert>
			</Snackbar>
			{/* SnacKbar 2*/}
			<Snackbar
				open={snackbarOpenError}
				autoHideDuration={3000} // Adjust the duration as needed
				onClose={handleCloseError}
				anchorOrigin={{ vertical: 'center', horizontal: 'center' }}
			>
				<Alert onClose={handleCloseError} severity="error" variant="filled">
					{errortext}
				</Alert>
			</Snackbar>
		</>
	);
}

export default EMRimport;
